import { useTRPC } from "../../../../trpc/client";
import { useQueryClient, useMutation } from "@tanstack/react-query";

export function useSetCardPaymentActivation(
  onSuccess: () => void,
  onError: (error: unknown) => void
) {
  const trpc = useTRPC();
  const queryClient = useQueryClient();

  const markManualErpSyncMutation = useMutation({
    ...trpc.invoices.setCardPaymentActivation.mutationOptions(),
    onSuccess,
    onError,
  });

  const setCardPaymentActivation = (
    merchantid: string,
    invoiceId: string,
    active: boolean,
    callbacks?: { onSettled?: () => void }
  ) => {
    markManualErpSyncMutation.mutate(
      { rentalsMerchantId: merchantid, id: invoiceId, active },
      {
        onSuccess: () => {
          queryClient.invalidateQueries({ queryKey: trpc.invoices.list.queryKey() });
          setTimeout(() => callbacks?.onSettled?.(), 10000);
        },
        onError: () => {
          callbacks?.onSettled?.();
        },
      }
    );
  };

  return { setCardPaymentActivation };
}
